import React, { useState } from 'react';
import { FAQ_TITLE, FAQS } from '../constants/content';
import { Reveal } from './Reveal';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white py-12 b760:py-16" data-id="element-56" data-mp="1blk9oxqpn104">
      <div className="mx-auto max-w-3xl px-4 b720:px-6" data-id="element-57" data-mp="1gjlrlfcegua0">
        <Reveal className="text-center" data-id="element-58" data-mp="1gk5b30hp7qq5">
          <h2 className="font-display text-2xl font-700 uppercase leading-tight text-night b640:text-4xl" data-id="element-59" data-mp="2496bq1kahxkv">
            {FAQ_TITLE}
          </h2>
        </Reveal>

        <Reveal className="mt-8" data-id="element-60" data-mp="28a9titlwe3oq">
          <ul className="space-y-3" data-id="element-61" data-mp="1ujefz40geyet">
            {FAQS.map((faq, index) => {
            const isOpen = openIndex === index;
            return <li key={faq.q} className="overflow-hidden rounded-xl border border-night/12 bg-cream" data-id="element-62" data-mp="1zh6ewhzinksi" data-mpi={index}>
                  <h3 data-id="element-63" data-mp="2ryilb2jj47np">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left font-600 text-night transition-colors hover:bg-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-bordo" data-id="element-64" data-mp="2rztxnqr1inqf">
                      <span className="text-sm b640:text-base" data-id="element-65" data-mp="1ohgedowy5bxo">{faq.q}</span>
                      <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" className={`shrink-0 text-bordo transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-66" data-mp="1jjetqzjvh4k3">
                        <path d="M5 7.5l5 5 5-5" data-id="element-67" data-mp="23991hapkpghv" />
                      </svg>
                    </button>
                  </h3>
                  {isOpen && <div id={`faq-panel-${index}`} className="border-t border-night/10 bg-white px-4 py-3.5 text-sm leading-relaxed text-night/85 b640:text-base" data-id="element-68" data-mp="2c8w6s7lfb6g7">
                      {faq.a}
                    </div>}
                </li>;
          })}
          </ul>
        </Reveal>
      </div>
    </section>;
}